export default __webpack_public_path__ + "static/media/actionServo.d18ac2c1.svg";